import { numberFormatter } from '@qred/fe-cp-formatting-helpers';
import { useSelector } from 'react-redux';
import { RootState } from '~/store';

export const useNumberFormatter = () => {
  const market = useSelector((state: RootState) => state.intl.market);

  const formatter = numberFormatter(market);

  return formatter;
};
